import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { getOnlineNode } from "../../../core/getNode";
import { encrypt } from "../../../utils/helpers";
import { useScreenContext } from "../../../partials/screenContext";

import { Public } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
  FormHelperText,
  Box,
} from "@mui/material";

import { Col, Row } from "react-bootstrap";
import packageJson from "../../../../package.json";

const appVersion = packageJson.version;

export default function Domain(props) {
  const [subdomain, setSubdomain] = useState("");
  const [loginType, setLoginType] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [hideLogin, setHideLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const timestamp = new Date().getTime();
  const handshake = encrypt("tauriApp");

  const [data, setData] = useState({});
  const dispatch = useDispatch();
  const { setCurrentScreen } = useScreenContext();

  useEffect(() => {
    fetch(`https://app-download.companyapp.net/credentials/domains.php`, {
      method: "GET",
      timeout: 30,
      headers: {
        "Cache-Control": "no-cache",
        "X-Token": handshake,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          setErrorMessage("Failed to retrieve required data. Please restart the app.");
          setError(true);
          setHideLogin(true);
        } else {
          return response.json(); // Parse the JSON response
        }

        setLoading(false);
      })
      .then((data) => {
        if (data) {
          setData(data); // Use the parsed JSON data
          setHideLogin(false);
          setError(false);
        }

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setErrorMessage("Failed to retrieve required data. Please restart the app.");
        setError(true);
        setHideLogin(false);
      });
  }, []);

  const checkSubdomain = (event) => {
    event.preventDefault();

    if (subdomain && subdomain.length > 1) {
      const sub = data[subdomain];
      if (sub) {
        getOnlineNode(`https://${sub.subdomain}.companyapp.net`, true)
          .then(() => {
            // success
            dispatch({
              type: "SAVE_SYSTEM",
              payload: sub,
            });

            setCurrentScreen("/login");
            // navigate('/login');
          })
          .catch((error) => {
            if (error.response.status === 403 || error.response.status === 401) {
              // success
              dispatch({
                type: "SAVE_SYSTEM",
                payload: sub,
              });

              setCurrentScreen("/login");
              // navigate('/login');
            } else {
              setErrorMessage("Failed to connect. This domain may be unreachable or non-existent.");
              setError(true);
            }
          });
      } else {
        setErrorMessage("Failed to connect. Please make sure you've entered the correct domain.");
        setError(true);
      }
    }
  };

  return (
    <main className={`login screen d-flex flex-column align-items-center mt-5`}>
      <Box sx={{ padding: 2 }}>
        <Row className="g-0">
          <Col xs={12}>
            <div className="form-group mb-5">
              <Row>
                <Col className="d-flex justify-content-center">
                  <Box>
                    <Typography>
                      The Add-In provides brand approved templates that make it simple to send professionally designed
                      emails to your clients. You can also easily add links to content from within the Companyapp
                      system. Register for a subscription here:{" "}
                      <a href="https://help.companyapp.net/sign-up/" target="_blank" rel="noreferrer">
                        https://help.companyapp.net/sign-up
                      </a>
                    </Typography>
                  </Box>
                </Col>
              </Row>
            </div>

            <form onSubmit={checkSubdomain}>
              <div className="form-group">
                <Row>
                  <Col xs={12}>
                    <FormControl error={isError} sx={{ width: 1 }}>
                      <InputLabel htmlFor="domain" sx={{ backgroundColor: "#fff" }}>
                        <Typography
                          sx={{
                            color: "primary.main",
                            fontSize: "16px",
                          }}
                        >
                          <Public
                            sx={{
                              paddingRight: "5px",
                              height: "25px",
                            }}
                          />
                          Domain
                        </Typography>
                      </InputLabel>
                      <OutlinedInput
                        disabled={hideLogin ? true : false}
                        id={"subdomain"}
                        value={subdomain}
                        autoComplete="off"
                        onInput={(e) => {
                          setSubdomain(e.target.value.toLowerCase());
                          setError(false);
                          setErrorMessage("");
                        }}
                      />
                      {isError && (
                        <FormHelperText sx={{ marginLeft: 0 }} id="subdomain-text">
                          {errorMessage}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Col>
                </Row>
              </div>

              <div className="form-group mt-3">
                <Row>
                  <Col className="d-flex justify-content-center">
                    {isLoading ? (
                      <CircularProgress />
                    ) : (
                      <Button
                        sx={{
                          minWidth: "250px",
                        }}
                        variant="contained"
                        type="submit"
                        disabled={subdomain && subdomain.length > 0 ? false : true}
                      >
                        Proceed
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>

              <div className="form-group mt-3">
                <Box
                  sx={{
                    width: "fit-content",
                    margin: "0px auto 0px auto",
                    display: "flex",
                    justifyContent: "center",
                    border: "2px solid rgba(0, 0, 0, 0.12)",
                    padding: "1px 5px",
                    borderRadius: "7px",
                  }}
                >
                  <Typography
                    variant="button"
                    sx={{
                      textTransform: "none",
                      fontWeight: "600",
                    }}
                  >
                    Ver {appVersion}
                  </Typography>
                </Box>
              </div>
            </form>
          </Col>
        </Row>
      </Box>
    </main>
  );
}
